import { IconDefinition } from '@fortawesome/fontawesome-common-types'
import { faQuestion } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Placement, Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { TooltipIconWrap } from './style'

type GenericTooltipProps = {
  message: string
  hasLeftMargin?: boolean
  hasRightMargin?: boolean
  bgColor?: string
  color?: string
  tooltipPlacement?: Placement
  icon?: IconDefinition
}

export const GenericTooltip = ({
  message,
  hasLeftMargin,
  hasRightMargin,
  bgColor,
  color,
  tooltipPlacement = 'left',
  icon = faQuestion,
}: GenericTooltipProps) => {
  return (
    <Tooltip text={message} hasArrow placement={tooltipPlacement}>
      <TooltipIconWrap
        hasMarginLeft={hasLeftMargin}
        hasRightMargin={hasRightMargin}
        color={color}
        bgColor={bgColor}
      >
        <FontAwesomeIcon
          icon={icon}
          size="xs"
          data-testid="generic-tooltip-icon"
        />
      </TooltipIconWrap>
    </Tooltip>
  )
}
